import { Icon } from "@iconify/react";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { brand } from "../../../context";
import { useSelector } from "react-redux";
import * as Flags from "country-flag-icons/react/1x1";
import { TranslationContext } from "../../../umbilical_tools";

export const ContactUsModal = ({ onClose }) => {
  const { t } = useContext(TranslationContext);
  const contactInfos = useSelector(
    (state) => state?.WebsiteMetadata?.metadata?.contact_informations ?? []
  );

  const emails = [
    ...new Set(
      (contactInfos ?? []).filter((inf) => inf.email).map((i) => i.email)
    ),
  ];

  return (
    <div className="Modal Contactus">
      <div className="Modal__card Contactus__card" data-brand={brand}>
        <div
          className="Modal__card__header Contactus__card__header"
          data-brand={brand}>
          {t("contactUs")}{" "}
          <Icon
            className="Modal__card__header__icon"
            icon="humbleicons:times"
            onClick={onClose}
          />
        </div>
        <div className="Modal__card__body Contactus__card__body">
          <p>
            For any queries regarding your booking, or if you’d like to find out
            more about Travily, please email or call us. We are more than happy
            to answer any questions you may have.
          </p>
          <div
            className="Contactus__card__section-container"
            data-brand={brand}>
            {(contactInfos ?? []).filter((inf) => inf.phone).length > 0 && (
              <div className="Contactus__card__section">
                <Icon
                  icon="ic:baseline-local-phone"
                  className="Contactus__card__section__icon"
                />
                <h6>{t("ourContactNumbersAre")}:</h6>
              </div>
            )}
            {(contactInfos ?? [])
              .filter((inf) => inf.phone)
              .map((inf, idx) => {
                const Comp = Flags?.[inf.name];
                return (
                  <div
                    className="Contactus__card__section"
                    data-noicon={Comp ? false : true}
                    key={idx}>
                    {Comp ? <Comp /> : <strong>Tel {idx + 1}: </strong>}
                    <a href={`tel:${inf.phone}`}>{inf.phone}</a>
                  </div>
                );
              })}
          </div>
          <div
            className="Contactus__card__section-container"
            data-brand={brand}>
            {emails.map((eml, idx) => (
              <div className="Contactus__card__section" key={idx}>
                <Icon
                  icon="ic:baseline-email"
                  className="Contactus__card__section__icon"
                />
                <a href={`mailto:${eml}`}>{eml}</a>
              </div>
            ))}
          </div>
          {brand === "travily" && (
            <div
              className="Contactus__card__section-container"
              data-brand={brand}>
              {(contactInfos ?? []).filter((inf) => inf.phone).length > 0 && (
                <div className="Contactus__card__section" data-noicon={true}>
                  <h6>{t("operationalHours")}:</h6>
                </div>
              )}
              <div className="Contactus__card__section" data-noicon={true}>
                <p>
                  <strong>{t("monday_to_friday")}:</strong> 8.00am to 6:00pm ICT
                  <br />
                  (Thailand time)
                  <br />
                  <strong>{t("saturday")}:</strong> {t("closed")}
                  <br />
                  <strong>{t("sunday")}:</strong> {t("closed")}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
ContactUsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
